export const CLOUD_MARKETPLACE_ACTIVATION_PATH = "/cloud-marketplace/activate";
export const CLOUD_MARKETPLACE_NONCE_KEY =
  "gcp_marketplace_activation_nonce";
export const CLOUD_MARKETPLACE_REDIRECT_ERROR_KEY =
  "gcp_marketplace_activation_error";

const MAX_ACTIVATION_NONCE_LENGTH = 512;
const MAX_REDIRECT_ERROR_LENGTH = 128;

function isActivationPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, "") === CLOUD_MARKETPLACE_ACTIVATION_PATH;
}

export function captureCloudMarketplaceActivationRedirect(): void {
  if (
    typeof window === "undefined" ||
    !isActivationPath(window.location.pathname)
  ) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const rawNonce = params.get("marketplace_state")?.trim() || "";
  const rawError = params.get("marketplace_error")?.trim() || "";
  if (!rawNonce && !rawError) return;

  if (rawError) {
    window.sessionStorage.removeItem(CLOUD_MARKETPLACE_NONCE_KEY);
    window.sessionStorage.setItem(
      CLOUD_MARKETPLACE_REDIRECT_ERROR_KEY,
      rawError.slice(0, MAX_REDIRECT_ERROR_LENGTH),
    );
  } else if (rawNonce.length <= MAX_ACTIVATION_NONCE_LENGTH) {
    window.sessionStorage.setItem(CLOUD_MARKETPLACE_NONCE_KEY, rawNonce);
    window.sessionStorage.removeItem(
      CLOUD_MARKETPLACE_REDIRECT_ERROR_KEY,
    );
  }

  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${window.location.hash}`,
  );
}
